import Layout from '@/layout'

const config = {
    path: '/websiteConfig',
    name: 'websiteConfig',
    component: Layout,
    hidden: false,
    meta: {
        title: '官网管理',
        icon: 'peizhi',
    },
    children: [
        {
            path: 'Cate',
            name: 'Cate',
            component: () => import('@/views/console/websiteConfig/FriendLink'),
            meta: {
                title: '友情链接',
            }
        },
        {
            path: 'Config',
            name: 'Config',
            component: () => import('@/views/console/websiteConfig/Config'),
            meta: {
                title: '信息配置',
            }
        },
        {
            path: 'Pages',
            name: 'Pages',
            component: () => import('@/views/console/websiteConfig/Pages'),
            meta: {
                title: '信息配置',
            }
        },
    ]
}

export default config
